
import * as angular from "angular";
import { IHttpException } from "@interfaces/IHttpException";
import { TranslationService } from "@services/translation.service";

export class MessageDialogService {

    static $inject = ["$mdDialog", "translationService"];

    constructor(
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly translationService: TranslationService
    ) { }

    handleError(err: angular.IHttpPromiseCallbackArg<IHttpException>, title: string = null, event: MouseEvent = null) {

        console.error(title, err, event);

        const dialogTitle = title || this.translationService.t("ErrorMessageService.GenericError");
        const errorDetail = err.data?.ExceptionMessage || this.translationService.t("ErrorMessageService.ConnectionError");

        const alertDialog = this.$mdDialog
            .alert()
            .title(dialogTitle)
            .textContent(errorDetail)
            .clickOutsideToClose(true)
            .ok(this.translationService.t("Common.OK"))
            .targetEvent(event);

        this.showMessage(alertDialog);
    }

    handleInfoMessage(title: string = null, message: string = null) {

        const alertDialog = this.$mdDialog
            .alert()
            .title(title)
            .textContent(message)
            .ok(this.translationService.t("Common.OK"));

        this.showMessage(alertDialog);
    }

    showMessage(dialog) {
        this.$mdDialog.show(dialog);
    }
}
